import { memo } from 'react'
import { Box as MuiBox, SxProps } from '@mui/material'
import { BannerGradientImage, BannerGradientMobileImage } from '@/assets'
import useDeviceType from '@/utils/hooks/useDeviceType'
import { Box } from '@/components/Layout'
import BannerAnimated from './BannerAnimated'
import { bannerBackgroundElementsStyles as styles } from './BannerBackgroundElements.style'
import { BannerBackgroundElementsProps } from './BannerBackgroundElements.types'

function BannerBackgroundElements({
  theme,
  hideGradientImage = false,
  animated = false,
}: BannerBackgroundElementsProps) {
  const { isMobile } = useDeviceType()

  return (
    <>
      {theme && (
        <Box sx={{ ...styles.backgroundGradient, bgcolor: theme.primaryColor } as SxProps} />
      )}
      {!theme && (
        <>
          {!hideGradientImage && (
            <MuiBox
              component="img"
              className="background-image"
              src={isMobile ? BannerGradientMobileImage : BannerGradientImage}
              alt=""
              sx={styles.backgroundImage}
            />
          )}
          <Box sx={styles.bannerBackgroundColor} />
        </>
      )}
      {animated && <BannerAnimated />}
    </>
  )
}

export default memo(BannerBackgroundElements)
